import { Observable } from 'rxjs';
import { RequestRoot } from 'types';

export abstract class RequestDataAccessService {
  abstract count(filter: Object): Observable<number>;
  abstract find(query: Object): Observable<RequestRoot[]>;
  abstract load(request: RequestRoot): Observable<RequestRoot>;
  abstract createUID(): Observable<string>;
  abstract save(request: RequestRoot): Observable<void>;
  abstract edit(request: RequestRoot): Observable<void>;
  abstract wipe(request: RequestRoot): Observable<void>;
}

export abstract class RequestDataAccessServiceConfig {
  abstract getServerURL(): string;
}
